import { render, staticRenderFns } from "./FormularioChapuzonKids2025.vue?vue&type=template&id=5e5568a2&scoped=true&"
import script from "./FormularioChapuzonKids2025.vue?vue&type=script&lang=ts&"
export * from "./FormularioChapuzonKids2025.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioChapuzonKids2025.vue?vue&type=style&index=0&id=5e5568a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5568a2",
  null
  
)

export default component.exports